<div class="d-flex">
  <app-mobile-header-main
    (titleClicked)="openTaxonomyMenu = $event"
    [mainTitle]="isOnFolder ? publicFolder?.name || currentFolder?.name : translateService.instant('menu.myDocuments')"
    menulink="/menu/documentos"
  ></app-mobile-header-main>
  <div class="taxonomy-overlay" [class.taxonomy-overlay-active]="openTaxonomyMenu" (click)="openTaxonomyMenu = false"></div>
  @if (urlParamsService.params.sidebar) {
    <app-taxonomy
      [mainTitle]="isOnFolder ? ('documents.folders' | translate) : ('documents.documents' | translate)"
      allowSearch
      [(isSearchOpen)]="isSearchOpen"
      (isSearchOpenChange)="toggleSearch($event)"
      [class.isMenuMobileOpen]="openTaxonomyMenu"
    >
      <app-documents-taxonomy
        [isSearchOpen]="isSearchOpen"
        [listPath]="'default'"
        (sortingChange)="loadDocuments({ page: 1, search: searchQuery }); loadFolders({ page: 1, search: searchQuery })"
        (newFolderButtonClick)="openCreateFolderModal()"
      >
      </app-documents-taxonomy>
    </app-taxonomy>
  }
</div>
<div class="holder">
  @if (isSearchOpen && urlParamsService.params.sidebar) {
    <app-documents-search
      [(search)]="searchQuery"
      (searchChange)="loadDocuments({ page: 1, search: $event }); loadFolders({ page: 1, search: $event })"
      (closeClick)="isSearchOpen = false; toggleSearch(isSearchOpen)"
      @slideDownUpTrigger
    ></app-documents-search>
  }
  <div class="d-flex flex-column w-100 fixedMain">
    <div class="documents">
      <app-electron-deprecation-warning></app-electron-deprecation-warning>
      <app-verification-warning [currentUser]="currentUser" (currentUserChange)="currentUser = $event"></app-verification-warning>

      <!-- TODO: Remover após a data da promocao/blackFriday/carnaval -->
      @if (currentUser && appService.isEventSale() && appService.isEventSaleBannerVisible() && appService.isUserEligibleForEventSale(currentUser)) {
        <div class="sale__banner carnaval">
          <p class="m-0" [innerHTML]="'documents.carnivalPromotion' | translate"></p>
          <a routerLink="/perfil/planos" class="btn-S btn-filled">{{ 'documents.access' | translate }}</a>
          <button type="button" class="btn-S btn-text icon-only" (click)="appService.hideEventSaleBanner()"><i class="fa-regular fa-xmark"></i></button>
        </div>
      }

      <!--      <app-payment-warning></app-payment-warning>-->
      @if (isShowingDocumentsWithoutOrg() && !isSearchOpen) {
        <div class="documents__header">
          <h2 class="documents__title">{{ 'documents.unorganizedDocuments' | translate }}</h2>
          <app-search [(query)]="mobileSearch" (queryChange)="loadDocuments({ page: 1, search: { search: $event } })"></app-search>
        </div>

        @if (appService.listFormat === ListFormat.Box) {
          <app-documents-list-boxes
            [currentUser]="currentUser"
            [documents]="documentsWithoutOrg"
            [hidePagination]="isLoading || isLastPage || (documents && documents.length > 0) || pageNumber > 99"
            (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
            (signClick)="sign($event)"
            (folderClick)="openFoldersModal({ documents: $event })"
            (deleteClick)="delete($event, documentsWithoutOrg)"
            (transferClick)="transfer($event)"
            (toggleBlockClick)="toggleBlock($event)"
            (resendWebhookClick)="resendWebhook($event)"
          >
          </app-documents-list-boxes>
        }

        @if (appService.listFormat === ListFormat.List) {
          <app-documents-list-table
            [currentUser]="currentUser"
            [hidePagination]="isLoading || isLastPage || (documents && documents.length > 0) || pageNumber > 99"
            (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
            (sortingChange)="loadDocuments({ page: 1, search: searchQuery })"
            [documents]="documentsWithoutOrg"
            (signClick)="sign($event)"
            (folderClick)="openFoldersModal({ documents: $event })"
            (deleteClick)="delete($event, documentsWithoutOrg)"
            (transferClick)="transfer($event)"
            (toggleBlockClick)="toggleBlock($event)"
            (resendSignaturesClick)="resendSignatures($event)"
            (resendWebhookClick)="resendWebhook($event)"
          >
          </app-documents-list-table>
        }
      }

      @if (!documents || documents.length > 0 || !isShowingDocumentsWithoutOrg() || isShared) {
        <div class="documents__header justify-content-start">
          @if (!route.snapshot.params.folderId) {
            @if ((isSearchOpen && searchQuery) || mobileSearch) {
              <h2 class="documents__title">
                {{ 'documents.searchResults' | translate }}
              </h2>
            } @else {
              <h2
                class="documents__title"
                [innerHTML]="
                  currentUser?.organization?.name ? ('documents.myDocumentsInOrganization' | translate: { organizationName: currentUser?.organization?.name }) : ('documents.myDocuments' | translate)
                "
              ></h2>
            }
          }

          @if (isShared) {
            <h2 class="documents__title">
              {{ ('menu.documentsIn' | translate) + ' ' + (publicFolder?.name || currentFolder?.name || '') }}
            </h2>
          } @else if (currentFolder?.name) {
            <h2 class="documents__title">
              @if (folders?.length > 0) {
                {{ 'menu.folders' | translate }}
                @if (currentUser?.organization?.name) {
                  <span class="highlight">{{ ('shared.in' | translate) + ' ' + currentUser?.organization?.name }}</span>
                }
              } @else {
                {{ currentFolder.name }}
              }
            </h2>
          }

          @if (!urlParamsService.params.folderBreadCrumbs && currentUser?.currentPermissions.create_documents && (!isOnFolder || currentFolder?.is_editor)) {
            <button class="btn-S btn-outline d-flex ml-2 mb-3" (click)="routeToNewDocument()">
              {{ 'menu.createDocument' | translate }}
            </button>
          } @else if (isOnFolder && !isMobile) {
            <div class="d-flex ml-auto mb-2" placement="bottom-right" ngbDropdown>
              <button class="btn-M btn-text icon-end" ngbDropdownToggle>
                {{ 'documents.options' | translate }}
                <i class="far fa-ellipsis-v"></i>
              </button>

              <div ngbDropdownMenu>
                <button type="button" ngbDropdownItem (click)="openCreateFolderModal({ folder: currentFolder })" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-folder-plus"></i>
                  {{ 'menu.newFolder' | translate }}
                </button>
                <button type="button" ngbDropdownItem (click)="routeToNewDocument()" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-file-plus"></i>
                  {{ 'menu.createDocument' | translate }}
                </button>

                <div class="dropdown-divider"></div>

                <button type="button" ngbDropdownItem (click)="openUpdateFolderModal(currentFolder, true)" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-pen-to-square"></i>
                  {{ 'button.rename' | translate }}
                </button>
                <button type="button" ngbDropdownItem (click)="openShareFolderModal(currentFolder)" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-share-from-square"></i>
                  {{ 'button.share' | translate }}
                </button>
                <button type="button" ngbDropdownItem (click)="openFoldersModal({ folder: currentFolder, isCurrentFolder: true })" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-box-archive"></i>
                  {{ 'button.archive' | translate }}
                </button>

                <div class="dropdown-divider"></div>

                <button type="button" [class.red]="currentFolder?.is_editor" ngbDropdownItem (click)="deleteCurrentFolder()" [disabled]="!currentFolder?.is_editor">
                  <i class="far fa-trash {{ currentFolder?.is_editor && 'red' }}"></i>
                  {{ 'button.exclude' | translate }}
                </button>
              </div>
            </div>
          }

          @if (route.snapshot.params.folderId && (currentFolder || publicFolder) && urlParamsService.params.folderBreadCrumbs) {
            <div class="documents__pathing">
              <a [routerLink]="['/pastas']">{{ 'documents.' + (isShared ? 'folders' : 'folders') | translate }}&nbsp; </a>
              @if (!isShared && currentFolder?.parentFolder) {
                <p class="documents__pathing__current">>&nbsp;&hellip;&nbsp;>&nbsp;</p>
                <a [routerLink]="['/pastas', currentFolder.parentFolder.id]">{{ currentFolder.parentFolder.name | truncate: 35 }}&nbsp;</a>
              }
              <p class="documents__pathing__current">
                >&nbsp;<b>{{ currentFolder?.name || publicFolder?.name | truncate: 35 }}</b>
              </p>
            </div>
          }

          @if (urlParamsService.params.sidebar) {
            @if (!isShowingDocumentsWithoutOrg()) {
              <app-search [(query)]="mobileSearch" (queryChange)="loadDocuments({ page: 1, search: { search: $event } }); loadFolders({ page: pageNumberFolders + 1, search: searchQuery })">
              </app-search>
            }

            @if (isSearchOpen && searchQuery && documents?.length > 0 && (!isOnFolder || folders?.length === 0)) {
              @if (folders && folders.length === 0) {
                <h2 class="documents__title">
                  {{ 'documents.searchResults' | translate }}
                </h2>
              }

              <button type="button" class="btn-text btn-M icon-start ml-2 mb-2" [disabled]="isLoading" (click)="exportDocuments(searchQuery)">
                <i class="far fa-file-csv"></i>&nbsp;{{ 'documents.export' | translate }}
              </button>
            }
          }
        </div>
      }

      @if (!urlParamsService.params.sidebar) {
        <div class="searchInset" [ngClass]="{ 'mb-1': isSearchOpen }">
          @if (isInternalUser(currentUser)) {
            <button class="btn-S icon-end btn-text-cancel btn-filled" (click)="toggleSearchOpen()" [ngClass]="{ searchOpen: isSearchOpen }">
              <span>{{ 'button.search' | translate }}</span>
              <i class="fa-regular fa-magnifying-glass"></i>
            </button>
            <div class="pipe"></div>
          }
          @if (!isSearchOpen) {
            <div ngbDropdown #statusDropdown="ngbDropdown">
              <button class="btn-S icon-end btn-text-cancel btn-filled" ngbDropdownToggle>
                <span>{{ (appService.documentStatusFilter ? 'documents.statusFilter.' + (appService.documentStatusFilter | lowercase) : 'documents.allDocuments') | translate }}</span>
                <i class="fa-solid" [ngClass]="statusDropdown.isOpen() ? 'fa-caret-up' : 'fa-caret-down'"></i>
              </button>
              <div ngbDropdownMenu>
                <button ngbDropdownItem (click)="changeStatusFilter(null)">{{ 'documents.allDocuments' | translate }}</button>
                <button ngbDropdownItem (click)="changeStatusFilter(DocumentStatusEnum.Signed)">{{ 'documents.statusFilter.signed' | translate }}</button>
                <button ngbDropdownItem (click)="changeStatusFilter(DocumentStatusEnum.Pending)">{{ 'documents.statusFilter.pending' | translate }}</button>
                <button ngbDropdownItem (click)="changeStatusFilter(DocumentStatusEnum.NotSigned)">{{ 'documents.statusFilter.not_signed' | translate }}</button>
                <button ngbDropdownItem (click)="changeStatusFilter(DocumentStatusEnum.Rejected)">{{ 'documents.statusFilter.rejected' | translate }}</button>
              </div>
            </div>
          }
        </div>

        @if (isSearchOpen) {
          <app-documents-search
            class="inset"
            [(search)]="searchQuery"
            [searchConfig]="{ hideMemberOrGroup: true, hideIncludeDeleted: true, hideIncludeArchived: true }"
            (searchChange)="loadDocuments({ page: 1, search: $event })"
            (closeClick)="isSearchOpen = false; toggleSearch(isSearchOpen)"
            @slideDownUpTrigger
          ></app-documents-search>
        }
      }

      @if (urlParamsService.params.folderBreadCrumbs && isOnFolder && folders?.length > 0) {
        <app-folders-list-boxes
          [folders]="folders"
          [hidePagination]="isLoading || isLastPageFolders"
          [isEditorParent]="currentFolder?.is_editor"
          [memberId]="memberId"
          (loadPageClick)="loadFolders({ page: pageNumberFolders + 1, search: searchQuery })"
          (updateClick)="openUpdateFolderModal($event)"
          (shareClick)="openShareFolderModal($event)"
          (folderClick)="openFoldersModal({ folder: $event })"
          (deleteClick)="deleteFolder($event)"
        >
        </app-folders-list-boxes>
      }

      @if (currentFolder?.name && documents?.length > 0 && folders?.length > 0) {
        @if (urlParamsService.params.folderBreadCrumbs) {
          <hr />
        }

        @if (!isMobile) {
          <div class="documents__header justify-content-start">
            <h2 class="documents__title">
              {{ 'menu.documents' | translate }} <span class="highlight">{{ ('shared.in' | translate) + ' ' + currentFolder?.name }}</span>
            </h2>

            @if (isSearchOpen && searchQuery && documents?.length > 0) {
              <button type="button" class="btn-text btn-M icon-start ml-2 mb-2" [disabled]="isLoading" (click)="exportDocuments(searchQuery)">
                <i class="far fa-file-csv"></i>&nbsp;{{ 'documents.export' | translate }}
              </button>
            }
          </div>
        }
      }

      @if (
        currentUser &&
        !searchQuery &&
        !mobileSearch &&
        !appService.documentStatusFilter &&
        documents?.length === 0 &&
        (isOnFolder || documentsWithoutOrg?.length === 0) &&
        (!isOnFolder || !folders || folders?.length === 0 || !!publicFolder || !urlParamsService.params.folderBreadCrumbs)
      ) {
        <div class="documents-empty">
          <img src="/assets/alerts/confirmation-2.svg" alt="" />
          <p class="documents-empty__title">{{ (isOnFolder && urlParamsService.params.folderBreadCrumbs ? 'documents.emptyFolder' : 'documents.noDocumentsHere') | translate }}</p>

          @if (urlParamsService.params.folderBreadCrumbs) {
            <button type="button" routerLink="/pastas" class="btn-M btn-filled-cancel">{{ (isOnFolder ? 'documents.backToFolders' : 'button.accessFolders') | translate }}</button>
          }
          @if (currentUser?.currentPermissions.create_documents && (!isOnFolder || currentFolder?.is_editor)) {
            <button type="button" (click)="routeToNewDocument()" class="btn-M btn-filled">
              {{ 'documents.createADocument' | translate }}
            </button>
          }
        </div>
      } @else if (currentUser && !isLoading && documents && (searchQuery || mobileSearch || appService.documentStatusFilter) && documents?.length === 0 && (!isOnFolder || folders?.length === 0)) {
        <div class="documents-filtered-empty">
          <div class="documents-filtered-empty_title">{{ 'settings.nothingHere' | translate }}</div>
          <div class="documents-filtered-empty_text">
            <span>{{ 'documents.noDocumentsMatchingFilter' | translate }}</span>
          </div>
          <button type="button" class="default-button" (click)="clearFilters()">{{ 'documents.clearFilters' | translate }}</button>
        </div>
      }

      @if (appService.listFormat === ListFormat.Box) {
        <app-documents-list-boxes
          [currentUser]="currentUser"
          [hidePagination]="isLoading || isLastPage || pageNumber > 99"
          (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
          [documents]="documents"
          (signClick)="sign($event)"
          (folderClick)="openFoldersModal({ documents: $event })"
          (deleteClick)="delete($event, documents)"
          (restoreClick)="transfer($event, true)"
          (transferClick)="transfer($event)"
          (toggleBlockClick)="toggleBlock($event)"
          (resendWebhookClick)="resendWebhook($event)"
        >
        </app-documents-list-boxes>
      }

      @if (appService.listFormat === ListFormat.List) {
        <app-documents-list-table
          [currentUser]="currentUser"
          [hidePagination]="isLoading || isLastPage || pageNumber > 99"
          (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
          (sortingChange)="loadDocuments({ page: 1, search: searchQuery })"
          [documents]="documents"
          (signClick)="sign($event)"
          (folderClick)="openFoldersModal({ documents: $event })"
          (deleteClick)="delete($event, documents)"
          (restoreClick)="transfer($event, true)"
          (transferClick)="transfer($event)"
          (toggleBlockClick)="toggleBlock($event)"
          (resendSignaturesClick)="resendSignatures($event)"
          (resendWebhookClick)="resendWebhook($event)"
        >
        </app-documents-list-table>
      }

      @if (isShared && !publicFolder?.is_allowed_user && publicFolder?.has_password) {
        <div class="protected__container">
          <div class="d-flex gap-2 flex-column">
            <p class="protected__title">{{ 'documents.shareFolder.protectedFolder' | translate }}</p>
            <p class="protected__description">{{ 'documents.shareFolder.protectedFolderDesc' | translate }}</p>
          </div>
          <img src="/assets/alerts/lock.svg" alt="" />

          <form [formGroup]="protectedFolderForm" (submit)="unblockFolder()" class="d-flex gap-3 flex-column w-100" novalidate>
            <label class="field__holder password" [appFormControlWrap]="protectedFolderForm.get('password')">
              <input type="password" class="field" formControlName="password" name="password" autocomplete="current-password" minlength="8" maxlength="255" required appShowPassword data-sentry-mask />
              <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
            </label>

            <button class="btn-M btn-filled d-flex ml-auto" type="submit" [disabled]="protectedFolderForm.invalid">{{ 'documents.unblock' | translate }}</button>
          </form>
        </div>
      }
    </div>
  </div>
</div>
